import Template40Svelte from './Template40.svelte';

export default class Template40 extends BaseView {

    initialize({
        model,
        taskView
    }) {
        // To use the newer Svelte technology, create a proxy backbone view.
        // which has all the methods of a backbone view, but proxies the most
        // important methods to the svelte view.
        const svelteView = this.addSvelteChildView(
            this.$el,
            Template40Svelte,
            {
                model,
                response: taskView.response,
                syncResponse: taskView.saveResponse.bind(taskView)
            }
        );

        const methodsToProxy = [
            'showAnswer', 'showAuthorAnswer', 'hideAnswer', 'lockAnswer',
            'unlockAnswer', 'getCorrectAnswer', 'getStudentAnswer'
        ]

        for (const method of methodsToProxy) {
            this[method] = svelteView[method].bind(svelteView);
        }
    }
}
